var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 1.726,
    x2: 21.241,
    y1: 8.3,
    y2: 17.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0175bc",
    d: "M11 3h2.5v2.5H11z",
    opacity: 1,
    "data-original": "#0175bc"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#01010110",
    d: "M11 5.25h2.5v.25H11z",
    opacity: 1,
    "data-original": "#01010110"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11 3h2.5v.25H11z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0175bc",
    d: "M11 6h2.5v2.5H11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    d: "M11 8.25h2.5v.25H11z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11 6h2.5v.25H11z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0175bc",
    d: "M11 9h2.5v2.5H11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    d: "M11 11.25h2.5v.25H11z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11 9h2.5v.25H11z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0175bc",
    d: "M8 6h2.5v2.5H8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    d: "M8 8.25h2.5v.25H8z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 6h2.5v.25H8z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0175bc",
    d: "M8 9h2.5v2.5H8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    d: "M8 11.25h2.5v.25H8z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 9h2.5v.25H8z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0175bc",
    d: "M5 6h2.5v2.5H5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    d: "M5 8.25h2.5v.25H5z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5 6h2.5v.25H5z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0175bc",
    d: "M5 9h2.5v2.5H5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    d: "M5 11.25h2.5v.25H5z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5 9h2.5v.25H5z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0175bc",
    d: "M2 9h2.5v2.5H2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    d: "M2 11.25h2.5v.25H2z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2 9h2.5v.25H2z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0175bc",
    d: "M14 9h2.5v2.5H14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    d: "M14 11.25h2.5v.25H14z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14 9h2.5v.25H14z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0175bc",
    d: "M23.595 11.223c-.07-.045-1.498-.947-2.849-.732-.327-1.37-1.583-2.222-1.644-2.263l-.348-.231-.29.3a1.3 1.3 0 0 0-.176.248c-.225.392-.55 1.269-.37 2.89a.524.524 0 0 1-.126.412.455.455 0 0 1-.344.153H0v.5C0 20.172 5.595 21 8 21c6.193 0 10.498-3.762 12.377-7.077 2.476-.395 3.333-1.95 3.378-2.024l.245-.415z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.448 12H0v.25h17.448a.455.455 0 0 0 .344-.153.524.524 0 0 0 .126-.411c-.006-.052-.005-.093-.01-.143a.507.507 0 0 1-.116.304.455.455 0 0 1-.344.153zM23.595 11.223c-.07-.045-1.498-.947-2.849-.732-.327-1.37-1.583-2.222-1.644-2.263l-.348-.231-.29.3c-.02.021-.063.07-.118.154-.188.29-.51.985-.474 2.297.012-1.503.508-2.114.592-2.2l.29-.301.348.231c.061.041 1.317.894 1.644 2.263 1.35-.215 3.254.743 3.254.743z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    d: "M23.755 11.649c-.045.074-.902 1.63-3.378 2.024C18.498 16.988 14.193 20.75 8 20.75c-2.405 0-8-.828-8-8.5v.25C0 20.172 5.595 21 8 21c6.193 0 10.498-3.762 12.377-7.077 2.476-.395 3.333-1.95 3.378-2.024l.245-.415-.107-.069z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M13.5 6H11v2.5h2.5zm0 3H11v2.5h2.5zm3 0H14v2.5h2.5zm-3-6H11v2.5h2.5zm-3 3H8v2.5h2.5zm-6 3H2v2.5h2.5zm19.095 2.223c-.07-.045-1.498-.947-2.849-.732-.327-1.37-1.583-2.222-1.644-2.263l-.348-.231-.29.3a1.3 1.3 0 0 0-.176.248c-.225.392-.55 1.269-.37 2.89a.524.524 0 0 1-.126.412.455.455 0 0 1-.344.153H0v.5C0 20.172 5.595 21 8 21c6.193 0 10.498-3.762 12.377-7.077 2.476-.395 3.333-1.95 3.378-2.024l.245-.415zM10.5 9H8v2.5h2.5zm-3-3H5v2.5h2.5zm0 3H5v2.5h2.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocker);
export default __webpack_public_path__ + "static/media/docker.d25f241c64acfa0521f4e367b0e278e7.svg";
export { ForwardRef as ReactComponent };